import Image from 'next/image'

export default function Logo({ className }: { className?: string }) {
  return (
    <Image
      src="/brand/logo-512.png"
      alt="Silker AI"
      width={32}
      height={32}
      className={className}
    />
  )
}
